var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    stroke: "#000000",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {},
    cx: 48,
    cy: 33,
    rx: 14.521,
    ry: 14.521
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 83.1 65.957 C 83.1 66.146 83.086 66.334 83.059 66.521 L 83.074 66.521 L 83.074 75.073 C 83.074 77.834 80.835 80.073 78.074 80.073 L 17.926 80.073 C 15.165 80.073 12.926 77.834 12.926 75.073 L 12.926 66.521 L 12.941 66.521 C 12.914 66.334 12.9 66.146 12.9 65.957 C 12.9 59.542 28.615 54.342 48 54.342 C 67.385 54.342 83.1 59.542 83.1 65.957 Z",
    style: {}
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile3);
export default __webpack_public_path__ + "static/media/profile3.44983e14f78ba756a1ee5d4602f9a0fb.svg";
export { ForwardRef as ReactComponent };